import axios from 'axios'
import { constants } from '../../App.constants'

/**
 * The logged-in member's own contract details (dashboards-api
 * GET/PUT /organization/:orgId/memberDetails), for the renewal flows'
 * "Confirm your details" step. cb(err, details); err is
 * { status, code, message, fields } where fields names each invalid field.
 */

const detailsUrl = () => constants.dashboardBaseUrl + '/organization/' + constants.selectedOrg + '/memberDetails'

const config = () => ({
    headers: {
        'Content-Type': 'application/json',
        'login-token': localStorage.getItem('loginToken')
    }
})

const failure = (error) => {
    const res = error && error.response
    const body = (res && res.data) || {}
    return { status: res ? res.status : 0, code: body.code || null, message: body.message || null, fields: body.fields || null }
}

const settle = async (request, cb) => {
    try {
        const payload = await request()
        const body = (payload && payload.data) || {}
        if (body.error) {
            return cb({ status: payload.status || 0, code: body.code || null, message: body.message || null, fields: body.fields || null })
        }
        cb(null, body.data)
    } catch (error) {
        cb(failure(error))
    }
}

export const getMemberDetails = (cb) => async () => settle(() => axios.get(detailsUrl(), config()), cb)

export const saveMemberDetails = (details, cb) => async () => settle(() => axios.put(detailsUrl(), details, config()), cb)
